import React, { useState } from 'react';
import { Card, Button, Table, Badge, Spinner, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { BAOVELUANANCOSO_API } from '@app/utils/apiUrl';
import { trangThaiBaoVeCoSoValue } from '@app/utils/define';
import { Get, DeleteSingle } from '@app/utils/httpProvider';
import moment from 'moment';
import { toast } from 'react-toastify';
import { ConfirmModal } from '@app/modules/modal/ConfirmModal';
import BaoVeCoSoAdd from './BaoVeCoSoAdd';
import BaoVeCoSoEdit from './BaoVeCoSoEdit';
import QuyetDinhBaoVeModal from './QuyetDinhBaoVeModal';
const BaoVeCoSo = ({ hoSoId }) => {
    const queryClient = useQueryClient();
    const [viewMode, setViewMode] = useState('list');
    const [dataEdit, setDataEdit] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);
    
    // Delete state
    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
    const [idWantDelete, setIdWantDelete] = useState('');
    
    const { isLoading, data: queryData, refetch } = useQuery(
        ['baoVeCoSoData', hoSoId],
        () => Get(`${BAOVELUANANCOSO_API.GET_BY_HOSO_ID}/${hoSoId}`),
        { 
            enabled: !!hoSoId,
            keepPreviousData: true
        }
    );

    let dataList = [];
    if (queryData) {
        if (Array.isArray(queryData)) {
            dataList = queryData;
        } else if (queryData.data && Array.isArray(queryData.data)) {
            dataList = queryData.data;
        } else if (queryData.data?.$values) {
            dataList = queryData.data.$values;
        } else {
            dataList = [queryData];
        }
    }

    React.useEffect(() => {
        if (dataList && dataList.length > 0) {
            setSelectedRow(prev => {
                if (prev) {
                    const fresh = dataList.find(item => item.id === prev.id);
                    return fresh || dataList[0];
                }
                return dataList[0];
            });
        } else {
            setSelectedRow(null);
        }
    }, [dataList]);

    const deleteFunc = useMutation((id) => DeleteSingle(BAOVELUANANCOSO_API.DELETE_ITEM, id, null));

    const deleteAction = (id) => {
        setIdWantDelete(id);
        setOpenConfirmDeleteModal(true);
    };

    const acceptDelete = () => {
        if (!idWantDelete) return;

        deleteFunc.mutate(idWantDelete, {
            onSuccess: (res) => {
                if (res && (res.status === 200 || res.status === 201 || res.status === 204 || res.success)) {
                    toast.success('Xóa thành công');
                    queryClient.invalidateQueries(['duyetBaoVeCoSoData', hoSoId]);
                    refetch();
                } else {
                    toast.error(res?.message || 'Có lỗi xảy ra khi xóa');
                }
            },
            onError: (err) => {
                toast.error(err?.message || 'Có lỗi xảy ra');
            }
        });

        setOpenConfirmDeleteModal(false);
        setIdWantDelete('');
    };

    const cancelDelete = () => {
        setIdWantDelete('');
        setOpenConfirmDeleteModal(false);
    };

    const renderTooltip = (props, text) => (
        <Tooltip id="button-tooltip" {...props}>
            {text}
        </Tooltip>
    );

    const renderTrangThai = (val) => {
        switch (val) {
            case trangThaiBaoVeCoSoValue.choQuyetDinh: return <Badge variant="warning">Chờ quyết định</Badge>;
            case trangThaiBaoVeCoSoValue.choBaoVe: return <Badge variant="info">Chờ bảo vệ</Badge>;
            case trangThaiBaoVeCoSoValue.hoanThanh: return <Badge variant="success">Hoàn thành</Badge>;
            default: return <Badge variant="secondary">Chưa xác định</Badge>;
        }
    };

    return (
        <>
        <Card className="card-sticky-layout">
            <Card.Header>
                <div className="d-flex justify-content-between align-items-center">
                    <h5 className="font-weight-bold text-primary m-0">Bảo vệ luận án cơ sở</h5>
                    <Button variant="success" size="sm" onClick={() => setViewMode('add')}>
                        <i className="fas fa-plus mr-1"></i> Thêm mới
                    </Button>
                </div>
            </Card.Header>
            <Card.Body>
                {isLoading ? (
                    <div className="text-center p-5">
                        <Spinner animation="border" variant="primary" />
                    </div>
                ) : (
                    <>
                        <div className="table-responsive">
                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                        <th className="text-center" width="50">STT</th>
                                        <th className="text-center">Ngày bảo vệ dự kiến</th>
                                        <th className="text-center">Trạng thái</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {dataList && dataList.length > 0 ? (
                                        dataList.map((item, index) => (
                                            <tr 
                                                key={item.id}
                                                onClick={() => setSelectedRow(item)}
                                                style={{ cursor: 'pointer' }}
                                                className={selectedRow?.id === item.id ? 'table-primary' : ''}
                                            >
                                                <td className="text-center">{index + 1}</td>
                                                <td className="text-center">
                                                    {item.ngayBaoVe ? moment(item.ngayBaoVe).format('DD/MM/YYYY') : ''}
                                                </td>
                                                <td className="text-center">{renderTrangThai(item.trangThai)}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="3" className="text-center text-muted">
                                                Chưa có dữ liệu Bảo vệ luận án cơ sở
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                        <ConfirmModal
                            isOpen={openConfirmDeleteModal}
                            confirmType="delete"
                            goBackAfterDelete={false}
                            handleAccept={acceptDelete}
                            handleCancel={cancelDelete}
                            content="Bản ghi này"
                        />
                    </>
                )}
            </Card.Body>
            {!isLoading && (
                <Card.Footer className="bg-white card-footer-sticky">
                    <div className="d-flex justify-content-end pr-4">
                        <Button 
                            variant="warning" 
                            size="sm" 
                            className="mr-2 text-white"
                            onClick={() => { setDataEdit(selectedRow); setViewMode('edit'); }} 
                            disabled={!selectedRow || selectedRow.trangThai !== trangThaiBaoVeCoSoValue.choQuyetDinh}
                        >
                            <i className="fas fa-edit mr-1"></i> Sửa
                        </Button>
                        <Button 
                            variant="danger" 
                            size="sm"
                            className="mr-2"
                            onClick={() => deleteAction(selectedRow?.id)}
                            disabled={!selectedRow || selectedRow.trangThai !== trangThaiBaoVeCoSoValue.choQuyetDinh}
                        >
                            <i className="fas fa-trash mr-1"></i> Xóa
                        </Button>
                        <Button 
                            variant="primary" 
                            size="sm" 
                            onClick={() => { setDataEdit(selectedRow); setViewMode('quyetDinhBaoVe'); }}
                            disabled={!selectedRow}
                        >
                            <i className="fas fa-check-double mr-1"></i> Quyết định bảo vệ
                        </Button>
                    </div>
                </Card.Footer>
            )}
        </Card>

        {viewMode === 'add' && <BaoVeCoSoAdd hoSoId={hoSoId} setViewMode={setViewMode} refreshList={refetch} />}
        {viewMode === 'edit' && dataEdit && <BaoVeCoSoEdit hoSoId={hoSoId} dataEdit={dataEdit} setViewMode={setViewMode} refreshList={refetch} />}
        {viewMode === 'quyetDinhBaoVe' && dataEdit && (
            <QuyetDinhBaoVeModal
                dataEdit={dataEdit}
                setViewMode={setViewMode}
                isView={true}
                isUserView={true}
            />
        )}
        </>
    );
};

export default BaoVeCoSo;
